import { render, staticRenderFns } from "./CreativesList.vue?vue&type=template&id=1b7c3183&scoped=true&"
import script from "./CreativesList.vue?vue&type=script&lang=js&"
export * from "./CreativesList.vue?vue&type=script&lang=js&"
import style0 from "./CreativesList.vue?vue&type=style&index=0&id=1b7c3183&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c3183",
  null
  
)

export default component.exports